export const setAllDoctypes = (data={}) => {
    return {
        type: 'SET_ALLDOCTYPE',
        payload: data
    } 
}

export const setDoctypeTranslations = (data) => {
    return {
        type: 'SET_DOCTYPETRANSLATIONS',
        payload: data
    } 
}

export const setFiletypeTranslations = (data) => {
    return {
        type: 'SET_FILETYPETRANSLATIONS',
        payload: data
    } 
}

export const setAllFiletypes = (data) => {
    return {
        type: 'SET_ALLFILETYPES',
        payload: data
    }
}

export const setAllRoles = (data) => {
    return {
        type: 'SET_ALLROLES',
        payload: data
    }
}

export const setAllRolesLabels = (data) => {
    return {
        type: 'SET_ALLROLESLABELS',
        payload: data
    }
}

export const setNFUDocs = (data) => {
    return {
        type: 'SET_NFUDOCS',
        payload: data
    }
}

export const setAllRelations = (data) => {
    return {
        type: 'SET_ALLRELATIONS',
        payload: data
    }
}

export const setAllGroups = (data) => {
    return {
        type: 'SET_ALLGROUPS',
        payload: data
    }
}

export const setRelation = (data={}) => {
    return {
        type: 'SET_RELATION',
        payload: data
    }
}

export const setUserRights = (data={}) => {
    return {
        type: 'SET_USERRIGHTS',
        payload: data
    }
}

export const setContent = (data={}) => {
    return {
        type: 'SET_CONTENT',
        payload: data
    }
}

export const setUserData = (data={}) => {
    return {
        type: 'SET_USERDATA',
        payload: data
    }
}